module.exports = __webpack_public_path__ + "img/is.382aa116.svg";